/* eslint-disable angular/module-name */
angular.module('zc.agencies', [
  'ngResource',
  'zc.commonApi',
  'zc.core',
  'zc.projects'
]);



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/agencies/zc.agencies.module.js